import React from 'react';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { useFeatures } from '~/react-hooks/use-features';
import UpgradeSvg from './upgrade.svg';
import { startUpgradeModalFlow } from '~/App/Components/Modals/UpgradeModalFlow';
import { UpgradeModalTrigger } from '~/App/Components/Modals/UpgradeModalFlow/util';

export default function GenericUpgradeButton() {
  const { canSwitchPlan } = useFeatures();

  const onClick = () => {
    startUpgradeModalFlow({
      trigger: UpgradeModalTrigger.UpgradeButton,
      reason: 'Upgrade plan from the nav header',
    });
  };

  if (!canSwitchPlan) {
    return <></>;
  }

  return (
    <>
      <Button
        className='h-10 py-0 v2-bg-yellow-200 hover:v2-bg-yellow-300 v2-border-yellow-200 hover:v2-border-yellow-300'
        variant={ButtonVariant.Secondary}
        onClick={onClick}
      >
        <UpgradeSvg className='h-4 relative top-[3px] mr-2' />
        Upgrade
      </Button>
    </>
  );
}
